<template>
  <tr>
    <td>
      <strong>{{ yacht.id }}</strong>
    </td>
    <td>
      <router-link
        :to="{ name: showLogisticsChecklist ? 'yachtLogisticsChecklist' : 'yachtDelivery', params: { id: yacht.id }}"
        target="_blank"
      >
        {{ yacht.name || 'Unknown Name' }}
      </router-link>
    </td>
    <td v-if="!showLogisticsChecklist">
      <div
        v-if="!yacht.hull_number"
        class="grey--text text--lighten-1"
      >
        n/a
      </div>
      <div v-else>
        {{ yacht.hull_number }}
      </div>
    </td>
    <td
      v-if="!showLogisticsChecklist"
      class="text-no-wrap"
    >
      <div
        v-if="!yacht.model.full_label"
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
      <div
        v-else
        style="max-width: 150px; text-overflow: ellipsis; overflow: hidden"
      >
        {{ yacht.model.label }}
        <div class="font-weight-light grey--text text--darken-2">
          {{ yacht.model.manufacturer.name }}
        </div>
      </div>
    </td>
    <td v-if="!showLogisticsChecklist">
      <div
        v-if="!yacht.delivery_year"
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
      <div v-else>
        {{ yacht.delivery_year }}
      </div>
    </td>
    <td v-if="!showLogisticsChecklist">
      <div
        v-if="!yacht.current_step"
        class="grey--text text--lighten-1"
      >
        Pending
      </div>
      <div v-else>
        {{ yacht.current_step.title }}<br>
        <span class="grey--text">
          <strong>{{ yacht.current_step.estimated_at | moment('D MMM YYYY') }}</strong> &middot; {{ yacht.current_step.processor_name }}
        </span>
      </div>
    </td>
    <td v-if="!showLogisticsChecklist">
      <div
        v-if="!yacht.next_step"
        class="grey--text text--lighten-1"
      >
        Pending
      </div>
      <div v-else>
        {{ yacht.next_step.title }}<br>
        <span class="grey--text">
          Est <strong>{{ yacht.next_step.estimated_at | moment('D MMM YYYY') }}</strong> &middot; {{ yacht.next_step.processor_name }}
        </span>
      </div>
    </td>
    <td
      v-if="!showLogisticsChecklist"
      class="text-no-wrap"
    >
      <div
        v-if="yacht.country"
        style="max-width: 110px"
        class="text-truncate"
      >
        <flag
          v-if="yacht.country"
          :iso="yacht.country.code"
          class="mr-1"
          :squared="false"
        />
        <span
          v-if="yacht.destination_base"
        >
          {{ yacht.destination_base.name }}
        </span>
      </div>
      <div
        v-else
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
    </td>
    <td v-if="!showLogisticsChecklist">
      <div
        v-if="!yacht.final_delivery"
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
      <div v-else>
        {{ yacht.final_delivery_estimated_end_at | moment('D MMM YYYY') }}<br>
      </div>
    </td>
    <template v-if="showLogisticsChecklist">
      <td
        v-for="category in logisticsCategories"
        :key="category.key + yacht.id"
      >
        <span
          v-if="yacht.logistics_checklist && Object.hasOwn(yacht.logistics_checklist, category.key) && !!yacht.logistics_checklist[category.key]"
          class="success--text text-no-wrap"
        >
          <v-icon
            x-small
            left
            color="success"
          >
            check
          </v-icon>
          Done
        </span>
        <span
          v-else
          class="error--text text-no-wrap"
        >
          <v-icon
            x-small
            left
            color="error"
          >
            close
          </v-icon>
          Not Done
        </span>
      </td>
    </template>
  </tr>
</template>

<script>
  import Yacht from '@/models/Yacht'

  export default {
    name: 'LogisticsRow',
    props: {
      yacht: {
        type: Object,
        default: null
      },
      logisticsCategories: {
        type: Array,
        default: () => ([])
      },
      showLogisticsChecklist: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        statusData: Yacht.statusData,
        investmentStatusData: Yacht.investmentStatusData
      }
    },
    methods: {
      goToYacht(yachtId) {
        let route = this.$router.resolve({ name: 'yachtDashboard', params: { id: yachtId } })

        window.open(route.href, '_blank')
      }
    }
  }
</script>

<style scoped>

</style>
